import { Button } from "@bedrock/components";
import _ from 'lodash'
import React from "react";
import {$sType} from "@mpc/common";
 
export const FormContent = {
    base: {
        title: "基本信息",
        classNames: "base-form-content",
        content: [
            {
                label: "MPC供应商编号",
                componentClass: "input",
                formItemKey: "main_supplier.code",
                required: true,
                elementProps: {
                    maxLength: 160,
                    isCopy: true,
                }
            },
            {
                label: "简称",
                componentClass: "input",
                formItemKey: "main_supplier.abbr_name",
                required: true,
            },
            {
                label: "公司人数",
                componentClass: "inputNumber",
                formItemKey: "main_supplier.staff_amount",
                required: true,
            },
            {
                label: "企业风险查询",
                componentClass: "span",
                formItemKey: "main_supplier.staff_amount",
                render(renderData:any) {
                    const name = renderData?.main_supplier?.name
                    return <Button
                        type={'link'}
                        onClick={() => {
                            window.open(`https://www.tianyancha.com/search?key=${name}`, '_blank')
                        }}
                    >https://www.tianyancha.com/</Button>
                }
            },
            {
                label: "是否中国大陆",
                componentClass: "select",
                formItemKey: "main_supplier.area_type",
                required: true,
                elementProps: {
                    optionsKey: "SupplierAreaTypeEnum",
                }
            },
            {
                label: "供应商类型",
                componentClass: "select",
                formItemKey: "main_supplier.mdm_type",
                required: true,
                elementProps: {
                    optionsKey: "SupplierVendorTypeEnum",
                }
            },
            {
                label: "是否营利性机构",
                componentClass: "radio",
                formItemKey: "main_supplier.profit_type",
                required: true,
                elementProps: {
                    optionsKey: "SupplierProfitTypeEnum",
                }
            },
            {
                label: "是否有关联关系",
                componentClass: "radio",
                formItemKey: "main_supplier.former_employee_founded",
                required: true,
                elementProps: {
                    options: [
                        {
                            value: true,
                            name: '是'
                        },
                        {
                            value: false,
                            name: '否'
                        }
                    ],
                }
            },
            {
                label: "是否单一来源",
                componentClass: "radio",
                formItemKey: "main_supplier.single_source",
                col: 12,
                required: true,
                elementProps: {
                    options: [
                        {
                            value: true,
                            name: '是'
                        },
                        {
                            value: false,
                            name: '否'
                        }
                    ],
                }
            },
            {
                label: "公司地址",
                componentClass: "textarea",
                formItemKey: "main_supplier.address",
                col: 12,
            },
        ]
    },
    file: {
        title: "资质文件",
        classNames: "file-form-content",
        content: [
            {
                label: "资质文件",
                required: false,
                componentClass: "s3upload",
                formItemKey: "main_supplier.attachments",
            }
        ]
    },
    sever: {
        title: "服务信息",
        classNames: "sever-form-content",
        content: [
            {
                label: "服务类型",
                componentClass: "select",
                formItemKey: "channel_type",
                required: true,
                elementProps: {
                    optionsKey: "ChannelTypeEnum",
                    disabled: true,
                }
            },
            {
                label: "服务类型编号",
                componentClass: "input",
                formItemKey: "code",
                required: true,
                elementProps: {
                    isCopy: true,
                }
            },
            {
                label: "服务内容",
                componentClass: "textarea",
                formItemKey: "content.content",
                elementProps:{
                    maxLength: 500
                }
            },
            {
                label: "优势资源平台",
                componentClass: "select",
                formItemKey: "content.advantage_resource_platform",
                elementProps: {
                    optionsKey: "ChannelSupplierAdvantageResourcePlatformEnum",
                    multiple: true,
                }
            },
            {
                label: "主要客户",
                componentClass: "textarea",
                formItemKey: "content.main_customers",
                elementProps:{
                    maxLength: 500
                }
            },
            {
                label: "垫支量级",
                componentClass: "select",
                formItemKey: "content.advance_scale",
                required: true,
                elementProps: {
                    optionsKey: "ChannelSupplierAdvanceScaleEnum",
                }
            },
            {
                label: "服务案例 (简举)",
                componentClass: "textarea",
                formItemKey: "content.examples",
                elementProps:{
                    maxLength: 500
                }
            },
            {
                label: "网易游戏案例 (简举)",
                componentClass: "textarea",
                formItemKey: "content.net_ease_game_examples",
                col: 12,
                show: (data: any) => {
                    return $sType === 'inner'
                },
                elementProps:{
                    maxLength: 500
                }
            },
            {
                label: "推荐项目组",
                componentClass: "input",
                formItemKey: "content.recommended_team",
                show: (data: any) => {
                    return $sType === 'inner'
                }
            },
            {
                label: "推荐人",
                componentClass: "input",
                formItemKey: "content.recommender",
                show: (data: any) => {
                    return $sType === 'inner'
                }
            },
            {
                label: "推荐人邮箱",
                componentClass: "input",
                formItemKey: "content.recommender_mail",
                show: (data: any) => {
                    return $sType === 'inner'
                }
            },
            {
                label: "推荐人与代理商建联背景",
                componentClass: "textarea",
                formItemKey: "content.recommender_relationship",
                show: (data: any) => {
                    return $sType === 'inner'
                },
                elementProps:{
                    maxLength: 500
                }
            },
            {
                label: "推荐理由",
                componentClass: "textarea",
                formItemKey: "content.recommendation_reason",
                show: (data: any) => {
                    return $sType === 'inner'
                },
                elementProps:{
                    maxLength: 500
                }
            },
        ]
    },
    principalUser: {
        title: "负责人",
        classNames: "principal-form-content",
        formItemKey: "principals",
    },
    contactUser: {
        title: "对接人",
        classNames: "docking-form-content",
        formItemKey: "contacts",
    },
    accountList: {
        title: "账号信息",
        classNames: "docking-form-userInfo",
        formItemKey: "account_list",
    }
}


// 搜集带点key列表
const getFormItemKey = (dataList, list = []) => {
    dataList.forEach(n => {
        if (n.formItemKey) list.push(n.formItemKey)
        if (Array.isArray(n.content)) {
            getFormItemKey(n.content, list)
        }
    })
    return list
}

const FormItemKeyList = getFormItemKey(Object.values(FormContent))


// formItem层通过formItemKey转成数组处理
export function supplierForm2Data(formObj: any) {
    // const data: any = {};
    // // 遍历表单对象中的每一个键值对
    // for (const [key, value] of Object.entries(formObj)) {
    //     // 使用点分割键
    //     const parts = key.split('.');
    //     // 从数据对象的根部开始
    //     let obj = data;
    //     for (let i = 0; i < parts.length; i++) {
    //         const part = parts[i];
    //         if (i === parts.length - 1) {
    //             // 如果这是最后一部分，设置值
    //             obj[part] = value;
    //         } else {
    //             // 否则，移动到对象的下一部分，如果必要的话创建它
    //             obj = obj[part] = obj[part] || {};
    //         }
    //     }
    // }
    return formObj;
}



export function supplierData2Form(dataObj: any) {
    // const formData: any = {}
    // FormItemKeyList.forEach(key => {
    //     formData[key] = _.get(dataObj, key)
    // })
    return dataObj;
}



